import React, { createContext, useContext, useMemo, useState } from 'react'
import { assertContext as assert } from '@helpers'

const classroomEnvContext = createContext()
const classroomIdContext = createContext()

export const ClassroomEnvProvider = ({ env, children, id }) => {
  const [idState] = useState(() => id)
  return (
    <classroomEnvContext.Provider value={env}>
      <classroomIdContext.Provider value={idState}>
        {children}
      </classroomIdContext.Provider>
    </classroomEnvContext.Provider>
  )
}

export const useClassroomEnv = () => {
  const env = assert(
    useContext(classroomEnvContext),
    'useClassroomEnv',
    'ClassroomEnvProvider'
  )

  const id = assert(
    useContext(classroomIdContext),
    'useClassroomEnv',
    'ClassroomIdProvider'
  )

  return useMemo(() => {
    return {
      env,
      id
    }
  }, [env, id])
}
